"use client";
import React from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@/components/ui/dropdownMenu";
import {
  CURRENCY_SELECTOR_OVERLAY_Z_CLASS,
  DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES,
} from "../constants";
import { cn } from "@/lib/utils";

interface CurrencyDropdownProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCurrency: string;
  onSelect: (code: string) => void;
  children: React.ReactElement;
}

export default function CurrencyDropdown({
  open,
  onOpenChange,
  selectedCurrency,
  onSelect,
  children,
}: CurrencyDropdownProps) {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        side="bottom"
        sideOffset={8}
        collisionPadding={16}
        className={cn(
          CURRENCY_SELECTOR_OVERLAY_Z_CLASS,
          "max-h-[min(280px,calc(100vh-2rem))] w-auto overflow-y-auto rounded p-0",
        )}
      >
        <DropdownMenuRadioGroup
          value={selectedCurrency}
          onValueChange={onSelect}
        >
          {DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES.map((currency) => {
            const isSelected = currency.code === selectedCurrency;

            return (
              <DropdownMenuRadioItem
                key={currency.code}
                value={currency.code}
                className={cn(
                  "flex cursor-pointer items-center gap-3 px-3 py-2 text-sm transition-colors hover:bg-putty-100 focus:bg-putty-100",
                  isSelected && "bg-putty-100 font-medium",
                )}
              >
                <span aria-hidden="true">{currency.flag}</span>
                <span className="font-semibold">
                  {currency.symbol}
                  {currency.code}
                </span>
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
